"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Map of property identifiers to user friendly names
 * @type {Object}
 */
var _default = {
  'itemType': 'Item Type',
  'title': 'Title',
  'dateAdded': 'Date Added',
  'dateModified': 'Date Modified',
  'source': 'Source',
  'notes': 'Notes',
  'tags': 'Tags',
  'attachments': 'Attachments',
  'related': 'Related',
  'url': 'URL',
  'rights': 'Rights',
  'series': 'Series',
  'volume': 'Volume',
  'issue': 'Issue',
  'edition': 'Edition',
  'place': 'Place',
  'publisher': 'Publisher',
  'pages': 'Pages',
  'ISBN': 'ISBN',
  'publicationTitle': 'Publication',
  'ISSN': 'ISSN',
  'date': 'Date',
  'year': 'Year',
  'section': 'Section',
  'callNumber': 'Call Number',
  'archive': 'Archive',
  'archiveLocation': 'Loc. in Archive',
  'libraryCatalog': 'Library Catalog',
  'distributor': 'Distributor',
  'extra': 'Extra',
  'journalAbbreviation': 'Journal Abbr',
  'DOI': 'DOI',
  'accessDate': 'Accessed',
  'seriesTitle': 'Series Title',
  'seriesText': 'Series Text',
  'seriesNumber': 'Series Number',
  'institution': 'Institution',
  'reportType': 'Report Type',
  'code': 'Code',
  'session': 'Session',
  'legislativeBody': 'Legislative Body',
  'history': 'History',
  'reporter': 'Reporter',
  'court': 'Court',
  'numberOfVolumes': '# of Volumes',
  'committee': 'Committee',
  'assignee': 'Assignee',
  'patentNumber': 'Patent Number',
  'priorityNumbers': 'Priority Numbers',
  'issueDate': 'Issue Date',
  'references': 'References',
  'legalStatus': 'Legal Status',
  'codeNumber': 'Code Number',
  'artworkMedium': 'Medium',
  'number': 'Number',
  'artworkSize': 'Artwork Size',
  'repository': 'Repository',
  'videoRecordingType': 'Recording Type',
  'interviewMedium': 'Medium',
  'letterType': 'Type',
  'manuscriptType': 'Type',
  'mapType': 'Type',
  'scale': 'Scale',
  'thesisType': 'Type',
  'websiteType': 'Website Type',
  'audioRecordingType': 'Recording Type',
  'label': 'Label',
  'presentationType': 'Type',
  'meetingName': 'Meeting Name',
  'studio': 'Studio',
  'runningTime': 'Running Time',
  'network': 'Network',
  'postType': 'Post Type',
  'audioFileType': 'File Type',
  'versionNumber': 'Version Number',
  'system': 'System',
  'company': 'Company',
  'conferenceName': 'Conference Name',
  'encyclopediaTitle': 'Encyclopedia Title',
  'dictionaryTitle': 'Dictionary Title',
  'language': 'Language',
  'programmingLanguage': 'Language',
  'university': 'University',
  'abstractNote': 'Abstract',
  'websiteTitle': 'Website Title',
  'reportNumber': 'Report Number',
  'billNumber': 'Bill Number',
  'codeVolume': 'Code Volume',
  'codePages': 'Code Pages',
  'dateDecided': 'Date Decided',
  'reporterVolume': 'Reporter Volume',
  'firstPage': 'First Page',
  'documentNumber': 'Document Number',
  'dateEnacted': 'Date Enacted',
  'publicLawNumber': 'Public Law Number',
  'country': 'Country',
  'applicationNumber': 'Application Number',
  'forumTitle': 'Forum/Listserv Title',
  'episodeNumber': 'Episode Number',
  'blogTitle': 'Blog Title',
  'caseName': 'Case Name',
  'nameOfAct': 'Name of Act',
  'subject': 'Subject',
  'proceedingsTitle': 'Proceedings Title',
  'bookTitle': 'Book Title',
  'shortTitle': 'Short Title',
  'docketNumber': 'Docket Number',
  'numPages': '# of Pages',
  'note': 'Note',
  'numChildren': '# of Children',
  'addedBy': 'Added By',
  'creator': 'Creator'
};
exports.default = _default;